export default "__VITE_ASSET__B4ic9LHw__"